import clsx from 'clsx';

//types
import type { AlbumCardGridLayoutType, AlbumCardMedia } from '@/lib/albums/types';

//libs
import { getCardGridStyles } from '@/lib/albums/getCardGridStyles';
import { getCardPostIconClasses, FbPostIcons } from '@/lib/albums/albumCardIconType';
import { FACEBOOK } from '@/lib/socialProfile';

//components
import Icon from '@/components/base/Icon';
import { MediaGridImage } from '@/components/pages/albums/AlbumCardMediaGrid/MediaGridImage';

function MediaGridFacebook({
    medias,
    gridLayout
}: {
    medias: AlbumCardMedia[];
    gridLayout: AlbumCardGridLayoutType;
}) {
    const maxMedias = gridLayout === 'card' ? 4 : 3;
    const renderedMedias = medias.length > maxMedias ? medias.slice(0, maxMedias) : medias;

    return (
        <>
            {renderedMedias.map((media, index) => {
                if (media.type === 'story' || media.type === 'mobile_status') {
                    return (
                        <span
                            data-testid="fb-specific-media-type"
                            key={index}
                            className={getCardGridStyles({
                                index: index + 1,
                                size: renderedMedias?.length,
                                network: FACEBOOK,
                                gridLayout
                            })}>
                            <span
                                className={clsx(
                                    'flex h-full w-full items-center justify-center',
                                    getCardPostIconClasses(media.type)
                                )}>
                                <Icon icon={FbPostIcons[media.type]} />
                            </span>
                        </span>
                    );
                }
                return (
                    <span
                        data-testid={
                            media.medias?.[0]?.image
                                ? 'grid-facebook-common'
                                : 'grid-facebook-thumbnail'
                        }
                        key={index}
                        className={getCardGridStyles({
                            index: index + 1,
                            size: medias?.length,
                            network: FACEBOOK,
                            gridLayout
                        })}>
                        <MediaGridImage
                            index={index}
                            image={media.medias?.[0]?.image ?? media?.medias?.[0]?.thumbnail}
                            type={media?.type}
                            size={medias?.length}
                            gridLayout={gridLayout}
                        />
                    </span>
                );
            })}
        </>
    );
}

export default MediaGridFacebook;
